import AbandonedCallsModule from './UrgentFollowUpsModule/AbandonedCallsModule';
import AuthModule from './AuthModule';
import BrowserModule from './BrowserModule';
import DiagnosticsModule from './DiagnosticsModule';
import E911AddressModule from './E911AddressModule';
import FeatureFlagModule from './FeatureFlagModule';
import FullStoryModule from './FullStoryModule';
import InboxModule from './InboxModule';
import InteractionsModule from './InteractionsModule';
import LogEnvVars from './LogEnvModule';
import SentryModule from './SentryModule';
import ServiceModule from './ServiceModule';
import SoftPhoneModule from './SoftPhoneModule';
import TasksModule from './TasksModule';
import ToastModule from './ToastModule';
import UserStatusModule from './UserStatusModule';
import VirtualAgentFollowUpsModule from './UrgentFollowUpsModule/VirtualAgentFollowUpsModule';
import SecondChanceLeadsModule from './UrgentFollowUpsModule/SecondChanceLeadsModule';
import VoicemailsModule from './UrgentFollowUpsModule/VoicemailsModule';
import AnnouncementsModule from './AnnouncementsModule';
import AppStatusModule from './AppStatusModule';
import BrazeModule from './BrazeModule';
import PendoModule from './PendoModule';
import PusherModule from './PusherModule';
import KibanaModule from './KibanaModule';
import UrgentFollowUpsModule from './UrgentFollowUpsModule';
import CustomTasksModule from './CustomTasksModule';
import SpeedToLeadTasksModule from './SpeedToLeadTasksModule';
import TransfersModule from './TransfersModule';
import FrontEndSettingsModule from './FrontEndSettingsModule';
import IndexDbModule from './IndexDbModule';
import DebugModule from './DebugModule';
import TechniciansModule from './TechniciansModule';

const modules = [
  DebugModule,
  DiagnosticsModule,
  KibanaModule,
  SentryModule,
  LogEnvVars,
  FeatureFlagModule,
  FullStoryModule,
  BrazeModule,
  PendoModule,
  PusherModule,
  ServiceModule,
  TasksModule,
  SoftPhoneModule,
  InteractionsModule,
  UserStatusModule,
  InboxModule,
  ToastModule,
  BrowserModule,
  FrontEndSettingsModule,
  UrgentFollowUpsModule,
  AbandonedCallsModule,
  SecondChanceLeadsModule,
  VirtualAgentFollowUpsModule,
  VoicemailsModule,
  E911AddressModule,
  AnnouncementsModule,
  AppStatusModule,
  CustomTasksModule,
  SpeedToLeadTasksModule,
  TransfersModule,
  TechniciansModule,
  IndexDbModule,
  AuthModule, // keep this last
];
export default modules;
